export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_AD_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_AD_TENANT_ID || 'common'}`,
    redirectUri: window.location.origin || 'http://localhost:3000',
    postLogoutRedirectUri: window.location.origin || 'http://localhost:3000',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ['User.Read'],
};

export const graphCalendarRequest = {
  scopes: ['Calendars.ReadWrite'],
};

export const graphContactsRequest = {
  scopes: ['Contacts.ReadWrite'],
};

export const graphMailRequest = {
  scopes: ['Mail.Read'],
};
